import { LinkTo } from '@ember/routing';
import Component from '@glimmer/component';
import { pluralize } from 'ember-inflector';
import UiCard from 'garaje/components/ui/card';
import type DeskModel from 'garaje/models/desk';
import type FloorModel from 'garaje/models/floor';
import { filter } from 'macro-decorators';

interface DesksFloorCardSignature {
  Args: {
    floor: FloorModel;
  };
}

export default class DesksFloorCard extends Component<DesksFloorCardSignature> {
  @filter('args.floor.desks.content', (desk: DeskModel) => desk.placed)
  declare placedDesks: DeskModel[];

  // Cast required: Glint strict-mode types AsyncHasMany.length as
  // `number | ComputedProperty<number, number>`, which `pluralize` rejects.
  // Runtime is always a plain `number`, so the cast is a type-only narrowing.
  get totalDesks(): number {
    return this.args.floor.desks.length as number;
  }

  <template>
    <UiCard data-test-floor-card={{@floor.id}}>
      <div class="flex space-x-4">
        <div class="flex-1">
          <h4 class="text-carbon-70 mb-3">{{@floor.name}}</h4>
          <p data-test-floor-active-count class="text-sm text-carbon-50 my-0">
            {{pluralize this.totalDesks "desk"}}
            |
            {{pluralize @floor.assignableDesks.length "enabled desk"}}
            |
            {{if @floor.floorPlanUrl (pluralize this.placedDesks.length "placed desk") "no map"}}
          </p>
        </div>
        <LinkTo
          data-test-floor-details-cta={{@floor.id}}
          @route="desks.show"
          @model={{@floor.id}}
          class="btn btn--small btn--outline text-carbon-60 self-center"
        >
          <span>Details</span>
        </LinkTo>
      </div>
    </UiCard>
  </template>
}
